import React, { useEffect, useState } from 'react';
import { useScripts } from '../hooks/useScripts';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import Footer from '../components/Footer';
import { getEmailCredsUrl } from '../config';
import { identifyPosthogPerson } from '../utils/identifyPosthogPerson';
function Login() {
  useDocumentTitle('Login');
  useScripts();
  
  const [email, setEmail] = useState('');
  const [isEmailSending, setIsEmailSending] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  
  useEffect(() => {
    // Add login class to body for proper styling
    document.body.classList.add('login');
    
    // Cleanup: remove class when component unmounts
    return () => {
      document.body.classList.remove('login');
    };
  }, []);
  
  useEffect(() => {
    // Trigger animations when component mounts
    const triggerAnimations = () => {
      // Dispatch scroll event to trigger css3-animate-it library
      window.dispatchEvent(new Event('scroll'));
      
      // Also manually trigger animations for visible elements
      setTimeout(() => {
        const animatedElements = document.querySelectorAll('.animated');
        animatedElements.forEach((el) => {
          const rect = el.getBoundingClientRect();
          const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
          if (isVisible) {
            const originalClasses = el.className;
            el.className = originalClasses.replace(/\banimated\b/g, '').trim();
            void el.offsetHeight; // Force reflow
            setTimeout(() => {
              el.className = originalClasses;
            }, 10);
          }
        });
      }, 100);
    };
    
    // Trigger immediately and after a short delay
    triggerAnimations();
    setTimeout(triggerAnimations, 200);
    setTimeout(triggerAnimations, 500);
  }, []);
  
  const handleSendEmailToInbox = async (e) => {
    e.preventDefault();
    identifyPosthogPerson(email, { immediate: true });
    if (!email.trim()) return;
    setIsEmailSending(true);
    setErrorMessage(null);
    setSuccessMessage(null);
    try {
      const response = await fetch(getEmailCredsUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() }),
      });
      let data;
      try {
        data = await response.json();
      } catch {
        setErrorMessage('An error occurred. Please try again.');
        return;
      }
      const statusCode = data.statusCode ?? response.status;
      const body = data.body ?? data;
      const errMsg = typeof body === 'object' && body?.error ? body.error : null;
      if (statusCode === 200) {
        setSuccessMessage('Check your email for your VPN access and download link.');
        setErrorMessage(null);
      } else if (statusCode === 404) {
        setErrorMessage('No account found with this email.');
        setSuccessMessage(null);
      } else {
        setErrorMessage(errMsg || 'An error occurred. Please try again.');
        setSuccessMessage(null);
      }
    } catch (err) {
      console.error('Send VPN email error:', err);
      setErrorMessage('An error occurred. Please try again.');
      setSuccessMessage(null);
    } finally {
      setIsEmailSending(false);
    }
  };

  return (
    <>
      {/* Login Form */}
      <div id="login-form" className="form-contact animatedParent">
        <h3>Login</h3>
        <form
          className="animated growIn"
          onSubmit={(e) => e.preventDefault()}
        >
          <div className="form-group">
            <label>Email address</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                identifyPosthogPerson(e.target.value);
                setErrorMessage(null);
                setSuccessMessage(null);
              }}
              onBlur={(e) => identifyPosthogPerson(e.target.value, { immediate: true })}
              disabled={isEmailSending}
            />
          </div>
          {errorMessage && (
            <div className="form-error-message">
              {errorMessage}
            </div>
          )}
          {successMessage && (
            <div className="form-success-message" style={{ color: '#0a7b0a', marginBottom: '16px', fontSize: '14px' }}>
              {successMessage}
            </div>
          )}
          <div className="form-group text-center">
            <button
              type="button"
              onClick={handleSendEmailToInbox}
              disabled={isEmailSending || !email.trim()}
              style={{ width: '100%' }}
            >
              {isEmailSending ? 'Sending...' : 'Send My VPN access to my Email'}
            </button>
          </div>
          <div className="form-group text-center" style={{ marginTop: '20px' }}>
            <p style={{ fontSize: '14px', color: '#8198a6', margin: 0 }}>
              Don't have an account? <a href="/signup" style={{ color: '#2563eb', textDecoration: 'none', fontWeight: 500 }}>create account</a>
            </p>
          </div>
        </form>
      </div>
      
      <Footer />
    </>
  );
}

export default Login;
